<div class="shortcut-search-step-container">
  <div class="shortcut-search-step-content">
    <sg-text color="decorative-text-01" variant="sg-p4-big-paragraph">Ready for a shortcut?</sg-text>
    <sg-text class="shortcut-search-step-description" color="text-secondary" variant="sg-p3-standard">
      If you have a file name - just type / paste it below and you are ready to go!
    </sg-text>
    <div class="find-file-by-name-container">
      <form pbl-nform #shortcutSearchForm [model]="inspectorFormModel" [filter]="['fileName']" filterMode="include"></form>
      <sg-button
        (onClick)="findFile()"
        variant="secondary"
        [text]="findFileButton.label"
        [icon]="findFileButton.icon"
        [disabled]="shortcutSearchForm.form.controls.fileName.invalid"></sg-button>
    </div>
  </div>
  <div class="shortcut-search-step-footer">
    <sg-button
      (onClick)="skipToExpandedSearch()"
      class="ghost-button"
      size="medium"
      text="Skip this and continue to expanded search"
      icon="search"
      variant="ghost-secondary"></sg-button>
  </div>
</div>
